import { useQuery } from '@tanstack/react-query';
import { faTasks } from '@fortawesome/free-solid-svg-icons';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes, ContractPropertyDisplayNames } from '../Common';
import SlideForm from '../common/forms/SlideForm';
import HistorySection from '../common/history/HistorySection';
import HistoryTypeSelect from '../common/history/HistoryTypeSelect';

const contractHistorySections = [
    {
        key: 'general',
        heading: 'General Information',
        renderOptions: {
            propertyDisplayNames: ContractPropertyDisplayNames,
            simpleDate: true,
        },
    },
    {
        key: 'chargeTypes',
        heading: 'Charge Types',
        renderOptions: { propertyDisplayNames: ContractPropertyDisplayNames },
    },
    {
        key: 'locations',
        heading: 'Locations',
        renderOptions: { propertyDisplayNames: ContractPropertyDisplayNames },
    },
];

const contractHistoryTypeOptions = [
    { value: 'all', label: 'All versions' },
    ...contractHistorySections.map((section) => ({
        value: section.key,
        label: section.filterLabel ?? section.heading,
    })),
];

const ContractHistoryForm = ({
    id = 'contractHistoryForm', show, contractId, onClose,
}) => {
    const { data: fullHistory = {}, isFetching: loading } = useQuery({
        queryKey: ['contractFullHistory', contractId],
        queryFn: () => httpClient.js(ApiRoutes.contractHistory.byId(contractId)),
        enabled: show && Boolean(contractId),
    });

    return (
        <SlideForm
            loading={loading}
            show={show}
            id={id}
            formIcon={faTasks}
            formTitle="Contract History"
            onClose={onClose}
            initialValues={{ versionHistorySection: 'all' }}
            saveDisabled
            className="history-form"
        >
            {({ values }) => {
                const selectedSection = values.versionHistorySection ?? 'all';

                return (
                    <div className="w-100">
                        <HistoryTypeSelect options={contractHistoryTypeOptions} />

                        <HistorySection
                            historicalChangeCollection={fullHistory[selectedSection]}
                            renderOptions={{ propertyDisplayNames: ContractPropertyDisplayNames }}
                        />
                    </div>
                );
            }}
        </SlideForm>
    );
};

export default ContractHistoryForm;
